export const API_ERROR_KIND = {
  OFFLINE: "offline",
  FORBIDDEN: "forbidden",
  NOT_FOUND: "not_found",
  SERVER: "server",
  INVALID_RESPONSE: "invalid_response",
  UNKNOWN: "unknown",
};

export const classifyApiError = (error) => {
  const status = Number(error?.status) || null;
  const message = String(error?.message || "");
  const code = error?.errorCode || error?.code || null;

  const isOffline =
    (typeof navigator !== "undefined" && navigator.onLine === false) ||
    /failed to fetch|networkerror|network request failed|load failed/i.test(
      message,
    );

  if (isOffline) {
    return {
      kind: API_ERROR_KIND.OFFLINE,
      status,
      code,
      rawMessage: message || null,
    };
  }

  if (
    code === "invalid_response" ||
    message === "Unexpected response from API"
  ) {
    return {
      kind: API_ERROR_KIND.INVALID_RESPONSE,
      status,
      code: code || "invalid_response",
      rawMessage: message || null,
    };
  }

  if (status === 401 || status === 403) {
    return {
      kind: API_ERROR_KIND.FORBIDDEN,
      status,
      code,
      rawMessage: message || null,
    };
  }

  if (status === 404) {
    return {
      kind: API_ERROR_KIND.NOT_FOUND,
      status,
      code,
      rawMessage: message || null,
    };
  }

  if (status >= 500) {
    return {
      kind: API_ERROR_KIND.SERVER,
      status,
      code,
      rawMessage: message || null,
    };
  }

  return {
    kind: API_ERROR_KIND.UNKNOWN,
    status,
    code,
    rawMessage: message || null,
  };
};

export const getApiErrorCopy = (classified, t, namespace = "finance") => {
  const kind = classified?.kind || API_ERROR_KIND.UNKNOWN;

  return {
    title: t(`${namespace}:error_${kind}_title`),
    description: t(`${namespace}:error_${kind}_description`),
  };
};
